import { OfferingTypesEnum } from '@monetize/types/app';

export const getOfferingType = (
  type?: OfferingTypesEnum,
): {
  isSubscription: boolean;
  isOneTime: boolean;
  isMinCommit: boolean;
  isPercentOfTotal: boolean;
  isToken: boolean;
  isOnetimeToken: boolean;
} => {
  if (type) {
    return {
      isSubscription: type === OfferingTypesEnum.SUBSCRIPTION,
      isOneTime: type === OfferingTypesEnum.ONETIME,
      isMinCommit: type === OfferingTypesEnum.MIN_COMMIT,
      isPercentOfTotal: type === OfferingTypesEnum.CUSTOM_PERCENT_OF_TOTAL,
      isToken: type === OfferingTypesEnum.TOKEN,
      isOnetimeToken: type === OfferingTypesEnum.ONETIME_TOKEN,
    };
  }

  return {
    isSubscription: false,
    isOneTime: false,
    isMinCommit: false,
    isPercentOfTotal: false,
    isToken: false,
    isOnetimeToken: false,
  };
};
